<template>
  <h1 class="mb-4"><slot /></h1>
</template>

<script>
export default {
  name: "page-header"
};
</script>

<style></style>
